import type { RouteRecordRaw } from "vue-router";

export const miniToolRoutes: RouteRecordRaw[] = [
  // AI Mini Tools
  // Static routes before dynamic :id
  {
    path: "/ai/mini_tools",
    name: "mini-tools-index",
    component: () => import("./mini_tools/MiniToolPage.vue"),
    meta: {
      title: "tools_meta.ai_mini_tools_prefix",
    },
  },
  {
    path: "/ai/mini_tools/history",
    name: "mini-tools-history",
    component: () => import("./mini_tools/history.vue"),
    meta: {
      title: "tools_meta.ai_mini_tools_prefix",
    },
  },
  {
    path: "/ai/mini_tools/info",
    name: "ai_mini_tool-info",
    component: () => import("./mini_tools/info.vue"),
    meta: {
      namespace: "ai_mini_tool",
      title: "tools_meta.ai_mini_tools_prefix",
    },
  },
  {
    path: "/ai/mini_tools/:id",
    name: "mini-tools-show",
    component: () => import("./mini_tools/MiniToolDetailPage.vue"),
    meta: {
      title: "tools_meta.ai_mini_tools_prefix",
    },
  },
];
